<template>
  <div class="guideLine">
    <div class="guideTitle">
      {{ termsFromApi ? '' : '使用規範' }}
      <span class="close" @click="backTo">關閉</span>
    </div>
    <div v-if="termsFromApi" v-html="termsFromApi" class="guideContent"></div>
    <div v-else class="guideContent">
      <div>
        感謝您使用拍享券服務(以下稱「本服務」)本服務。本服務是由拍付國際資訊股份有限公司與康太數位整合股份有限公司負責經營。本服務係依據使用規範（以下簡稱「本規範」）提供各項服務（以下簡稱「本服務」），當您登錄本服務使用本服務時，即表示您已閱讀、瞭解並同意接受本條款之所有內容。此外，當您使用本服務的特定服務時，可能會依據該特定服務之性質，而須遵守本服務所另行公告之服務條款或相關規定。此另行公告之服務條款或相關規定亦均併入屬於本服務條款之一部分。
        本服務有權於任何時間修改或變更本條款之內容，並以頁面公告、電子信件發送、簡訊或其他方式通知您確認，若您於修改或變更後繼續使用本服務，視為您已閱讀、瞭解並同意接受本條款之修改或變更。如果您無法遵守本條款內容，或不同意本條款內容時，請您立即停止使用本服務。為確保您的權益，建議您經常確認本條款之最新條文內容。
        <br />
        <br />
        若您為未滿二十歲，應於您的家長（或監護人）閱讀、瞭解並同意本服務條款之所有內容及其後修改變更之內容後，才可以使用或繼續使用本服務。當您使用或繼續使用本服務時，即推定您的家長（或監護人）已閱讀、瞭解並同意接受本條款之所有內容及其後修改變更。
        <br />
        <br />
        當您違反本服務所聲明之條款時，本服務得終止您使用本服務。
      </div>
      <div>
        <br />
        1、資料連結
        <br />
        <br />
        您可能會因本服務上的連結而因此連結至其他業者經營的頁面，但不表示本服務與該等業者有任何關係。其他業者經營的頁面均由該業者自行負責，不屬本服務控制及負責範圍之內。您同意本服務無須為您連結至非屬於本服務之頁面所生之任何損害，負損害賠償之責任。本服務隨時會與其他公司、廠商等第三人（「內容提供者」）合作，由其提供內容供本服務刊登，本服務於刊登時均將註明內容提供者。基於尊重內容提供者之智慧財產權，本服務對其所提供之內容並不做實質之審查或修改，對該等內容之正確真偽亦不負任何責任。
      </div>
      <div>
        <br />
        2、隱私權政策
        <br />
        <br />
        為了能使用本服務，您必須於訂購流程中留下個人資料，您同意以下事項：
        <br />
        <br />
        （1）、您應填寫正確真實及完整的資料。如果您提供任何錯誤或不實的資料進行登錄，本服務有權暫停或終止您的使用權，並拒絕您使用本服務。
        <br />
        （2）、在本服務或公開發表內容中填入任何不當或不雅字眼，本服務將保留刪除您發表內容的權力。
        <br />
        （3）、同意將您所提供的個人資料用於本服務各項行銷活動；包括但不限於免費與付費贈獎活動。
        <br />
        （4）、同意本服務不定期發送電子報或商品訊息（EDM）至您所登錄的電子郵件位址，或利用電子郵件、實體郵件、電話、簡訊或其他方式進行商品行銷資訊之提供及其他服務。若您欲停止訂閱，請您來信客服中心，由客服人員為您處理。
        <br />
        您的資料會依【隱私權政策】受到保護與規範。您了解當您使用本服務時，您同意本服務依據隱私權政策進行您個人資料的蒐集與利用。本服務亦保留未來修改隱私權政策之權利，並以頁面公告、電子信件發送、簡訊或其他方式通知您，惟為確保您的權益，建議您經常確認隱私權政策之最新條文內容。
        <br />
        <br />
        若發現個人資料遭到盜用或有其他任何安全問題發生時，請您立即通知本服務。
      </div>
      <div>
        <br />
        3、交易行為
        <br />
        <br />
        （1）、本服務的【核銷系統】服務，僅提供訂單資訊系統方便您與各廠商／店家進行連絡電子票券兌換交易。當您透過本服務的核銷系統進行聯繫或是額外產生個人交易時，所產生的買賣行為僅存在您與各廠商或個人兩造之間。若有任何交易上的爭議與賠償問題，本服務將不做任何相關擔保責任。
        <br />
        （2）、您同意在本服務所進行的所有線上消費，都以本服務系統所自動記錄的電子交易資料為準，如有糾紛，亦以該電子交易資料為認定標準。若您發現交易資料不正確，應立即通知本服務。
        <br />
        （3）、若您於本服務訂購產品後，經由本服務退換貨、取消訂單之頻率過高，或任何對本服務造成系統負擔與資訊作業上之困擾或損害，經本服務判定為惡意行為時，本服務將保留拒絕交易或停止對您提供本服務之權利。
        <br />
        （4）、您可選擇將發票委由本服務捐贈予第三方之公益團體，並同意捐贈後即無法將該發票退回或重新開立。
      </div>
      <div>
        <br />
        4、享樂券使用條款
        <br />
        <br />
        （1）、若您持有之本服務適用的折扣碼扣抵兌換金額，不足之總額可使用Pi拍錢包付費，完成購買享樂券。
        <br />
        （2）、每筆享樂券於您購買時，將分別存入發行人於台新銀行、陽信銀行開立之信託專戶，專款專用，信託期間自發售日起算1年。所稱專用，係指供發行人履行交付商品或提供服務義務使用，以全程保障您的權益。
        <br />
        發行資訊：康太數位整合股份有限公司
        <br />
        地 址：台北市中山區中山北路一段11號13樓
        <br />
        統一編號：24317014
        <br />
        負 責 人：李易騰
        <br />
        實收資本額：180,000,000元
        <br />
        （3）、享樂券之服務內容由本服務合作之廠商／店家提供，本服務則為行銷與銷售服務提供者。請務必於兌換優惠期間內使用，並確實了解電子票券及商品頁面所載明之使用說明（包括但不限於：使用時段、事前預約規定、內用或外帶、每人使用限制）。
        <br />
        （4）、享樂券碼類型分為一維條碼、二維條碼、憑證序號，請您依本服務系統指示之方式開啟享樂券前往店家兌換該項商品或服務，店員將會依據您出示之享樂券進行憑證碼之核對，請您務必配合店員之核對程序，並於核對無誤後於店家之兌換商品簽收單簽上完整清晰之姓名與聯繫電話；消費者不得以其他格式之電子票券要求兌換商品。
        <br />
        （5）、享樂券不得與其他優惠合併使用，且於使用時恕無法兌換現金。
        <br />
        （6）、享樂券所載之序號，應妥善保存。若因享樂券遺失或公開序號造成序號被第三方兌換所產生之損失，須由訂購者自行承擔。
        <br />
        （7）、享樂券超過使用期限未使用，您可向本服務進行後續退款流程，作業手續費$0，相關流程請參【客服中心】，提醒您儘量於期限內使用完畢；
        P幣純點兌換專區商品不在此限，不提供退換貨服務。
        <br />
        （8）、部分電子票券是特定時間、特定場合所提供之服務（包括但不限於演唱會、音樂會或展覽），若因故未能於該特定時間、場合使用該服務，依法恕無法要求退費或另行補足差額重現該服務。
        <br />
        （9）、若提供商品或服務之店家於消費者使用電子票券前倒閉或因故無法提供商品或服務，您同意本服務得直接為您辦理後續退貨及退款。
      </div>
      <div>
        <br />
        5、暫停服務
        <br />
        <br />
        本服務有時候可能會出現中斷或故障等現象，或許將造成您使用上的不便、資料喪失、錯誤或其他經濟上損失等情形。您於使用本服務時宜自行採取防護措施。康太商城對於您因使用（或無法使用）本服務而造成的損害，除故意或重大過失外，不負任何賠償責任。
      </div>
      <div>
        <br />
        6、廣告
        <br />
        <br />
        您在本服務中瀏覽到的所有廣告內容均由各該廣告商、產品與服務的供應商所設計與提出。您對於廣告之正確性與可信度應自行斟酌與判斷。本服務僅接受委託予以刊登，不對前述廣告負擔保責任。
      </div>
      <div>
        <br />
        7、未成年之兒童及青少年之保護
        <br />
        <br />
        為確保兒童及青少年使用網路的安全，並避免隱私權受到侵犯，家長（或監護人）應協助未成年之兒童及青少年檢查並確認本服務保護個人資料的隱私權政策，再決定是否同意提出相關個人資料。
      </div>
      <div>
        <br />
        8、著作權及智慧財產權的保護
        <br />
        <br />
        本服務所使用之軟體或程式、頁面上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、頁面架構、頁面畫面的安排、網頁設計，除本公司有特別約定外，皆由本公司或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。
        任何人不得擅自使用、修改、重製、公開播送、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。任何人欲引用或轉載前述軟體、程式或頁面內容，必須依法取得本公司或其他權利人的事前書面同意。如有違反，您應對本公司負損害賠償責任（包括但不限於訴訟費用及律師費用等）。
      </div>
      <div>
        <br />
        9、您的法律義務及承諾
        <br />
        <br />
        絕不為任何非法目的或以任何非法方式使用本服務，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。您若係中華民國以外之使用者，並同意遵守所屬國家或地域之法令。
        <br />
        <br />
        您同意並保證不得利用本服務從事侵害他人權益或違法之行為，包括但不限於：
        <br />
        <br />
        （1）、違反依法律或契約所應負之保密義務；
        <br />
        （2）、冒用他人名義使用本服務；
        <br />
        （3）、傳輸或散佈電腦病毒；
        <br />
        （4）、其他本服務有正當理由認為不適當之行為
      </div>
      <div>
        <br />
        10、本條款之效力、準據法與管轄法院
        <br />
        <br />
        本條款中，任何條款之全部或一部份無效時，不影響其他約定之效力。
        <br />
        <br />
        您與本公司之權利義務關係，應依網路交易指導原則及中華民國法律定之；若發生任何爭議，以台灣台北地方法院為第一審管轄法院。
        <br />
        <br />
        本公司的任何聲明、條款如有未盡完善之處，將以最大誠意，依誠實信用、平等互惠原則，共商解決之道。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GuideLine',
  components: {},
  data: function() {
    return {
      termsFromApi: '',
    }
  },
  methods: {
    backTo() {
      this.$router.back()
    },
  },
  created() {
    this.termsFromApi = JSON.parse(
      window.localStorage.getItem('initial_config')
    ).terms.termsOfUse
  },
}
</script>

<style lang="scss" scoped>
.guideTitle {
  width: 100%;
  margin: 30px auto 10px;
  text-align: center;
  font-size: 22px;
  padding: 0 16px;
  position: relative;
  .close {
    position: absolute;
    top: 7px;
    right: 16px;
    font-size: 16px;
    text-decoration: underline;
    color: #222;
  }
}
.guideContent {
  padding: 0px 16px 20px;
}
</style>
